/**
 * Hook for managing selected encounter storage in sessionStorage.
 * Uses sessionStorage to keep encounter selection isolated per browser window/tab.
 */
export const useSelectedEncounter = (orgUuid: string | undefined) => {
  const key = orgUuid ? `${orgUuid}_selectedEncounter` : null;

  const getSelectedEncounter = () => {
    if (!key) return null;
    const stored = sessionStorage.getItem(key);
    if (!stored) return null;
    try {
      return JSON.parse(stored);
    } catch {
      return null;
    }
  };

  const setSelectedEncounter = (encounter: any) => {
    if (!key) return;
    sessionStorage.setItem(key, JSON.stringify(encounter));
  };

  const clearSelectedEncounter = () => {
    if (!key) return;
    sessionStorage.removeItem(key);
  };

  return { getSelectedEncounter, setSelectedEncounter, clearSelectedEncounter };
};
